module.exports = __webpack_public_path__ + "static/media/Service6image.09111c28.svg";